/*
 * Copyright (C) 2022 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 */
import { AbstractSubscriptionManager } from "./AbstractSubscriptionManager";
export class AbstractSetSubscriptionManager extends AbstractSubscriptionManager {
    constructor() {
        super(...arguments);
        this.listenerSet = new Set();
    }
    addListener(listener) {
        if (!this.listenerSet.has(listener)) {
            this.listenerSet.add(listener);
            this.subscribeOnce();
        }
    }
    removeListener(listener) {
        this.listenerSet.delete(listener);
        if (this.listenerSet.size === 0) {
            this.unsubscribe();
        }
    }
    refreshSubscriptions() {
        if (this.listenerSet.size > 0) {
            this.unsubscribe();
            this.subscribeOnce();
        }
    }
    forEachListener(method) {
        this.listenerSet.forEach(method);
    }
}
